import { render } from "./MessageBox.vue?vue&type=template&id=67e4c91b&scoped=true"
import script from "./MessageBox.vue?vue&type=script&lang=js"
export * from "./MessageBox.vue?vue&type=script&lang=js"

import "./MessageBox.vue?vue&type=style&index=0&id=67e4c91b&lang=scss&scoped=true"

import exportComponent from "E:\\Project-humblit_official_system\\humblit_official_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67e4c91b"]])

export default __exports__